/**
 * Search Typewriter Effect
 * Starts typing animation ONLY when search is opened (drawer or header focus).
 */
(function () {
  const WORDS = ['mat', 'böcker', 'beredskapsmat', 'kläder', 'klimatnytta'];
  const PREFIX = 'Sök efter ';
  const TYPE_SPEED = 80;
  const DELETE_SPEED = 50;
  const PAUSE_AFTER_TYPE = 2000;
  const PAUSE_AFTER_DELETE = 400;

  function startTypewriter(input) {
    if (!input) return;

    // Stop any existing animation on this input
    if (input._twTimeout) clearTimeout(input._twTimeout);

    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let stopped = false;

    input.placeholder = PREFIX;

    function tick() {
      if (stopped) return;

      const currentWord = WORDS[wordIndex];

      if (!isDeleting) {
        charIndex++;
        input.placeholder = PREFIX + currentWord.substring(0, charIndex);

        if (charIndex === currentWord.length) {
          isDeleting = true;
          input._twTimeout = setTimeout(tick, PAUSE_AFTER_TYPE);
          return;
        }
        input._twTimeout = setTimeout(tick, TYPE_SPEED);
      } else {
        charIndex--;
        input.placeholder = PREFIX + currentWord.substring(0, charIndex);

        if (charIndex === 0) {
          isDeleting = false;
          wordIndex = (wordIndex + 1) % WORDS.length;
          input._twTimeout = setTimeout(tick, PAUSE_AFTER_DELETE);
          return;
        }
        input._twTimeout = setTimeout(tick, DELETE_SPEED);
      }
    }

    // Stop when user starts typing
    function onInput() {
      if (input.value) {
        stopped = true;
        if (input._twTimeout) clearTimeout(input._twTimeout);
      }
    }

    // Stop and clean up when search closes
    function stop() {
      stopped = true;
      if (input._twTimeout) clearTimeout(input._twTimeout);
      input.removeEventListener('input', onInput);
      input._twStop = null;
    }

    input.addEventListener('input', onInput);
    input._twStop = stop;

    // Start after a small delay
    input._twTimeout = setTimeout(tick, 300);
  }

  function stopTypewriter(input) {
    if (input && input._twStop) input._twStop();
  }

  // --- Search Drawer (mobile) ---
  // Watch the <dialog> element for open attribute changes
  function watchDrawer() {
    const dialog = document.getElementById('search-drawer-dialog');
    if (!dialog) return;

    const obs = new MutationObserver(function () {
      const input = dialog.querySelector('.search__input');
      if (dialog.hasAttribute('open')) {
        // Drawer just opened — start animation
        if (input && !input.value) {
          startTypewriter(input);
        }
      } else {
        // Drawer closed — stop
        stopTypewriter(input);
      }
    });
    obs.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  // --- Header search (desktop) ---
  // Start when the desktop search input gets focus
  function watchHeader() {
    const headerInputs = document.querySelectorAll('.header__search .search__input');
    headerInputs.forEach(function (input) {
      input.addEventListener('focus', function () {
        if (!input.value) startTypewriter(input);
      });
      input.addEventListener('blur', function () {
        stopTypewriter(input);
        if (!input.value) input.placeholder = PREFIX + '...';
      });
    });
  }

  // --- Init ---
  function init() {
    watchDrawer();
    watchHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
